export default __webpack_public_path__ + "static/media/classic05.e9b18101.png";